import { create } from 'zustand';
import type { ActiveConnection, ConnectionStatus } from '@/types';

interface ConnectionStore {
  activeConnections: Record<string, ActiveConnection>;

  setStatus: (connectionId: string, status: ConnectionStatus, error?: string) => void;
  removeConnection: (connectionId: string) => void;
  isConnected: (connectionId: string) => boolean;
}

export const useConnectionStore = create<ConnectionStore>((set, get) => ({
  activeConnections: {},

  setStatus: (connectionId, status, error) => {
    set((s) => ({
      activeConnections: {
        ...s.activeConnections,
        [connectionId]: {
          connectionId,
          status,
          error,
          connectedAt: status === 'connected' ? new Date().toISOString() : s.activeConnections[connectionId]?.connectedAt,
        },
      },
    }));
  },

  removeConnection: (connectionId) => {
    set((s) => {
      const { [connectionId]: _, ...rest } = s.activeConnections;
      return { activeConnections: rest };
    });
  },

  isConnected: (connectionId) => {
    return get().activeConnections[connectionId]?.status === 'connected';
  },
}));
